(function () {
  'use strict';


var dy_lazyLoader_configuration = function () {
  var self = this;

  self.init();

};

dy_lazyLoader_configuration.prototype.init = function() {
  var self = this;

  self.configLazySizes();

};

dy_lazyLoader_configuration.prototype.configLazySizes = function() {
  //var self = this;

  /*----------------------------------------------------------------------------*/
  // Configure plugin lazysizes
  /*----------------------------------------------------------------------------*/
  window.lazySizesConfig = window.lazySizesConfig || {};

  window.lazySizesConfig.lazyClass = 'dy_lazyLoader_st_UNMOUNTED';
  // window.lazySizesConfig.preloadAfterLoad = 'false';
  window.lazySizesConfig.preloadClass = 'dy_lazyLoader_st_preload';
  window.lazySizesConfig.loadingClass = 'dy_lazyLoader_st_loading';
  window.lazySizesConfig.loadedClass = 'dy_lazyLoader_st_loaded';

  // Bloqquemaos el auto init del plugin
  window.lazySizesConfig.init = false;

  // Callback que determina la densidad máxima de las imágenes
  window.lazySizesConfig.getOptimumX = function(/*element*/){

    var image_density = 1;

    // Mobile
    if (dyDetection.is_mobile_tablet()) {
      image_density = window.devicePixelRatio * 0.8;
    } else {
      image_density = window.devicePixelRatio;
    }

    return image_density;
  };

};

/*----------------------------------------------------------------------------*/
// Component Public
/*----------------------------------------------------------------------------*/
  window.dy_lazyLoader_configuration = new dy_lazyLoader_configuration();

}());
